export enum Solutions {
    IndustrialVending = 1,
    ToolManegament = 2,
    IndustrialVendingToolManagement = 3
  }